/* vim: set ts=2 sw=2 sts=2 et: */

/**
 * Copyright (c) 2001-present X-Cart Holdings LLC. All rights reserved.
 * See https://www.x-cart.com/license-agreement.html for license details.
 */

export default class XCartModule {
  createModule() {
    return {
      namespaced: true,
      state() {
        return window.xcart;
      },
      getters: {
        xcart: state => state,
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/xcart.js